import React from 'react';
import axios from 'axios';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadIcon from '@material-ui/icons/CloudUpload';
import NewIcon from '@material-ui/icons/CreateNewFolder';
import NewClientIcon from '@material-ui/icons/People';
import RenameIcon from '@material-ui/icons/Adjust';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import DownloadAllIcon from '@material-ui/icons/CloudDownloadTwoTone';
import AllowMultipleDownloadIcon from '@material-ui/icons/PanoramaFishEye';
import ViewIcon from '@material-ui/icons/TextRotateUp';
import ListenAllIcon1 from '@material-ui/icons/Subscriptions'
import ListenAllIcon2 from '@material-ui/icons/SubscriptionsOutlined'

import DeliverReportIcon from '@material-ui/icons/Send';


import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import Tooltip from '@material-ui/core/Tooltip';

import SimpleDialog from './SimpleDialog';
import FormDialog from './FormDialog';
import ViewDialog from './ViewDialog';
import InfoDialog from './InfoDialog';
import DeliverReportDialog from './DeliverReportDialog';
import AssignRoleDialog from './AasignRoleDialog';
import Preview from './Preview';
import MetaData from './MetaData';
import History from './History';


import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import TextFiled from '@material-ui/core/TextField';


import 'gijgo/css/gijgo.css';

import $ from 'jquery';
import { Toolbar, Checkbox, Divider} from '@material-ui/core';
import DrapToUpload from './DragToUpload';

window.jQuery = $;
window.$ = $;
global.jQuery = $;
//const gijgo = 
require('gijgo');
//import('gijgo');

const FLAGABLETYPES = ['pdf','docx','doc','xlst','png','jpeg','bmp','zip','json','xml','txt','client','folder'];
const VIEWABLETYPES = ['pdf','docx','xlst','png','jpeg','bmp'];

export class Docx extends React.Component
{
    constructor(props){
        super(props);
        this.state = {
            expanded: null,
            selected: null,
            name:null,
            isFolderSelected: false,
            isFileSelected: false,

            tag: { meta: [], history: [], subscribe: [] },
            isAdmin: false,
            allRoles: []
        };

        this.initTree = this.initTree.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onUnSelected = this.onUnSelected.bind(this);
        this.laodClients = this.loadClients.bind(this);
        this.loadChildren = this.loadChildren.bind(this);
        this.deliverReport = this.deliverReport.bind(this);
        this.newClient = this.newClient.bind(this);
        this.create = this.create.bind(this);
        this.download = this.download.bind(this);
        this.downloadAllChecked = this.downloadAllChecked.bind(this);
        this.upload = this.upload.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.fileInputChanged = this.fileInputChanged.bind(this);
        this.rename = this.rename.bind(this);
        this.delete = this.delete.bind(this);
        this.assignRole = this.assignRole.bind(this);
        this.view = this.view.bind(this);
        this.contextMenu = this.contextMenu.bind(this);
        this.classes = props;

        this.onClientFilterChanged = this.onClientFilterChanged.bind(this);
        this.createContextMenu = this.createContextMenu.bind(this);
        this.createSidePanel = this.createSidePanel.bind(this);

        this.currentId = this.currentId.bind(this);
        this.currentName = this.currentName.bind(this);
        this.currentRoleName = this.currentRoleName.bind(this);
        this.currentNode = this.currentNode.bind(this);
        this.currentItem = this.currentItem.bind(this);

        this.showAxiosError = this.showAxiosError.bind(this);
    }
    appendFlagUrl(item){
        const type = (FLAGABLETYPES.indexOf(item.type) > -1)? item.type:'other';
        item.flagUrl = '/images/' + type + '.png';
        //item.flagUrl = '/images/pdf.png';
        item.checked = false;
        return item;
    }
    adjustImage(){
        $("img").attr('height','24');
    }
    showAxiosError(error){
        if(error.response && error.response.data){
            this.infoDialog.show(error.response.data,"ERROR: "+error.response.status,true);
        }else{
            this.infoDialog.show(JSON.stringify(error),"ERROR",true);
        }
    }
    loadClients(){
        axios.get('/api/docx/clients')
        .then(response => {
            this.data = response.data.map(node => this.appendFlagUrl(node));
            this.tree.render(this.data);
            this.adjustImage();
        });
    }
    loadIsAdmin() {
        axios.get('/api/docx/isAdmin')
            .then(response => {
                this.setState({ isAdmin: response.data });
            }).catch(this.showAxiosError);
    }
    loadAllRoles() {
        axios.get('/api/docx/allroles')
            .then(response => {
                this.setState({ allRoles: response.data });
            }).
            catch(this.showAxiosError);
    }
    loadChildren(id){
        const data = this.tree.getDataById(id);
        if(!data.hasChildren){
            return;
        }
        if(data.children != null){
            return;
        }
        axios.get('/api/docx/children?parentId='+id)
        .then(response => {
            response.data.forEach(item =>
                this.tree.addNode(this.appendFlagUrl(item), this.tree.getNodeById(id)));
            this.adjustImage();
        })
        .catch(this.showAxiosError);
    }
    currentId(){
        return this.state.selected;
    }
    currentName(){
        if(this.tree && this.state.selected){
            return this.tree.getDataById(this.state.selected).name;
        }else{
            return null;
        }
    }
    currentRoleName() {
        if (this.tree && this.state.selected) {
            return this.tree.getDataById(this.state.selected).roleName;
        } else {
            return null;
        }
    }
    currentNode(){
        if(this.tree && this.state.selected){
            return this.tree.getNodeById(this.state.selected);
        }else{
            return null;
        }
    }
    currentItem(){
        if(this.tree && this.state.selected){
            return this.tree.getDataById(this.state.selected);
        }else{
            return null;
        }
    }
    deliverReport(){
        this.deliverReportDialog.show();
    }
    newClient(){
        this.setState({pos:null});
        this.formDialog.show("New Client","",null,name => {
            axios.post("api/docx/newClient",{id:'a29d4a3c-d732-4acc-8401-5cdfa2c32064',name:name},{headers:{'Content-Type':'application/json'}})
            .then(response => {
                this.tree.addNode(this.appendFlagUrl(response.data),null);
                this.adjustImage();
            })
            .catch(this.showAxiosError);
        });
    }
    create(){
        this.setState({pos:null});
        this.formDialog.show("New Folder","Adding New Folder To "+this.currentName(),null,name => {
            axios.post("api/docx/create",{id:this.currentId(),name:name},{headers:{'Content-Type':'application/json'}})
            .then(response => {
                this.tree.addNode(this.appendFlagUrl(response.data),this.currentNode());
                this.adjustImage();
            })
            .catch(this.showAxiosError);
        });
    }
    download(){
        this.setState({pos:null});
        axios.get("api/docx/isFileExisted/"+this.currentId())
        .then(response => {
            window.open('api/docx/download/'+this.currentId());
        })
        .catch(this.showAxiosError);
    }
    downloadAllChecked() {
        var result = this.tree.getCheckedNodes();
        alert(result.join());
        result.forEach(id => {
            axios.get("api/docx/isFileExisted/" + id)
                .then(response => {
                    if (response.data) {
                        window.open('api/docx/download/' + id);
                    }
                })
                .catch(this.showAxiosError);
        });
    }
    upload(){
        this.setState({pos:null});
        this.fileInput.click();
    }
    uploadFile(files) {

        let data = new FormData();
        for (var i = 0; i < files.length; i++) {
            data.append('files', files[i], files[i].name);
        }
        axios.post('api/docx/upload/'+this.currentId(),
        data,
        {
            headers: {
                'accept': 'application/json',
                'Accept-Language': 'en-US,en;q=0.8',
                'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
              }
        }
        ).then(response => {
            response.data.forEach(item =>
                this.tree.addNode(this.appendFlagUrl(item), this.currentNode()));
            this.adjustImage();
            })
        .catch(this.showAxiosError);
    }
    fileInputChanged(){
        this.uploadFile(this.fileInput.files);
    }
    rename(){
        this.setState({pos:null});
        this.formDialog.show("Change Name","Changing Name for "+ this.currentName() + "?",this.currentName(),newName => {
            axios.post('api/docx/rename',{id:this.currentId(),name:newName},{headers:{'Content-Type':'application/json'}})
            .then(response => {
                
                this.tree.getChildren(this.currentNode(),false).forEach(child => {
                    this.tree.removeNode(this.tree.getNodeById(child));
                });

                let item = this.currentItem();
                item.children = null;
                item.name = response.data.name;
                this.tree.updateNode(this.currentId(),item);

                this.tree.collapse(this.currentNode());
            })
            .catch(this.showAxiosError);
        })
    }
    delete(){
        this.setState({pos:null});
        const name = this.currentName();
        this.simpleDialog.show("Are you sure to delete "+name + "?",r => {
            if(r){
                axios.delete('api/docx/delete/'+this.currentId())
                .then(response => this.tree.removeNode(this.currentNode()))
                .catch(this.showAxiosError);
            }
        });
    }
    assignRole() {
        this.setState({ pos: null });
        const name = this.currentName();
        const roleName = this.currentRoleName();
        const id = this.currentId();
        this.assignRoleDialog.show(name, roleName, (clientFromDialog, roleNameFromDialog) => {
            axios.post('api/docx/assignRoleName', { id: id, name: roleNameFromDialog }, { headers: { 'Content-Type': 'application/json' } })
                .then(response => {
                    this.currentItem().roleName = response.data.roleName;
                })
                .catch(this.showAxiosError);
        });
    }
    view(){
        this.setState({pos:null,isView:true});
    }
    contextMenu(e){
        this.setState({anchorEL:e.currentTarget,pos:{top:e.pageY,left:e.pageX}});
        e.stopPropagation();
        e.preventDefault();
    }
    onClientFilterChanged(value){
        const data = [];
        this.data.forEach(item => {
            if (!item.name) {
                return;
            }
            const nameInUppercase = item.name.toUpperCase();
            if (!value || !value.trim() || nameInUppercase.startsWith(value.toUpperCase())) {
                data.push(item);
            }
        });
        this.tree.render(data);
        this.adjustImage();
    }
    createSidePanel(isAdmin,isAllowUpload){
        if(!this.currentItem()){
            return '';
        }
        const fileType = this.currentItem()? this.currentItem().type:null;
        const filePath = this.currentItem()? 'api/docx/download/' + this.currentId() : null;
        return this.currentItem().hasChildren?
            (<div style={{ height: '65vh' }}>
                
                <MetaData rows={this.state.tag.meta} />
                {
                    isAdmin ? <History rows={this.state.tag.history} />:''
                }
                {
                    isAllowUpload?<DrapToUpload onUpload={this.uploadFile} />:''
                }
                
            </div>):
            (<div style={{height:'65vh'}}>
                <MetaData rows={this.state.tag.meta}/>
                {
                    isAdmin ? <History rows={this.state.tag.history} /> : ''
                }
                {this.state.isView?
                <Preview fileType={fileType} filePath={filePath}/> :''}
            </div>);
    }
    createContextMenu(){
        if(!this.state.selected){
            return '';
        };

        const isClient = this.currentItem() && this.currentItem().type === 'client';
        const isFolder = this.currentItem() && this.currentItem().hasChildren;
        const isViewable = this.currentItem() && VIEWABLETYPES.indexOf(this.currentItem().type) > -1;
        const name = this.currentItem() ? this.currentName() : null;
        const { isAdmin } = this.state;
        const isAllowAssignRole = false;// isAdmin && isClient;
        const isAllowNewClient = isAdmin && isClient;
        const isAllowNewFolder = isAdmin && isFolder;
        const isAllowRename = isAdmin;
        const isAllowPreview = !isFolder && isViewable;
        const isAllowDownload = !isFolder;
        const isAllowUpload = (isAdmin && isFolder) || (name && name.includes("Upload"));
        const isAllowDelete = isAdmin;
        return (
            <Menu id='context-menu' anchorOrigin={{vertical:'top',horizontal:'left'}} transformOrigin={{vertical:'top',horizontal:'left'}}
                anchorPosition={this.state.pos} anchorReference='anchorPosition'
                open={Boolean(this.state.pos)} onClose={() => this.setState({pos:null})}>
                {
                    isAllowAssignRole ?
                        <MenuItem onClick={this.assignRole}><ListItemIcon><NewClientIcon /></ListItemIcon><ListItemText>Assign Role</ListItemText></MenuItem> : ''
                } 
                {
                    isAllowNewClient?
                    <MenuItem onClick={this.newClient}><ListItemIcon><NewClientIcon/></ListItemIcon><ListItemText>New Client</ListItemText></MenuItem>:''
                } 
                {
                    isAllowPreview?
                    <MenuItem onClick={this.view}><ListItemIcon><ViewIcon/></ListItemIcon><ListItemText>Preview {name}</ListItemText></MenuItem>:''
                } 
                {
                    isAllowDownload?
                    <MenuItem onClick={this.download}><ListItemIcon><DownloadIcon/></ListItemIcon><ListItemText>Download {name}</ListItemText></MenuItem>:''
                } 
                {
                    isAllowNewFolder?
                    <MenuItem onClick={this.create}><ListItemIcon><NewIcon/></ListItemIcon><ListItemText>Add New Folder To {name}</ListItemText></MenuItem>:''
                }
                {
                    isAllowRename?
                    <MenuItem onClick={this.rename}><ListItemIcon><RenameIcon/></ListItemIcon><ListItemText>Rename {name}</ListItemText></MenuItem>:''
                } 
                {
                    isAllowUpload?
                    <MenuItem onClick={this.upload}><ListItemIcon><UploadIcon/></ListItemIcon><ListItemText>Upload To {name}</ListItemText></MenuItem>:''
                }    
                {
                    isAllowDelete?
                    <MenuItem onClick={this.delete} color='secondary'> <ListItemIcon><DeleteIcon/></ListItemIcon><ListItemText>Delete {name}</ListItemText></MenuItem>:''
                }
                {
                    <Divider />
                }
                {
                    (this.state.tag.listenAll != null)?
                    <MenuItem >
                        <ListItemIcon><ListenAllIcon1/></ListItemIcon>
                        <ListItemText>Listen {name} of All Clients</ListItemText>
                        <ListItemSecondaryAction>
                            <Checkbox checked={this.state.tag.listenAll}
                            onChange={e => {
                                const b = e.target.checked;
                                axios.get('api/docx/listenAll/'+this.currentId() + '/' + e.target.checked)
                                .then(response => {
                                    const tag = this.state.tag;
                                    tag.listenAll = b;
                                    this.setState({tag:tag});
                                })
                                .catch(error => alert(error.message));
                            }}/>
                        </ListItemSecondaryAction>
                    </MenuItem>
                    :'' 
                } 
                {
                    (this.state.tag.listenThis != null)?
                    <MenuItem >
                        <ListItemIcon><ListenAllIcon2/></ListItemIcon>
                        <ListItemText>Listen {name} of This Client</ListItemText>
                        <ListItemText/>
                        <ListItemSecondaryAction>
                            <Checkbox checked={this.state.tag.listenThis}
                            onChange={e => {
                                const b = e.target.checked;
                                axios.get('api/docx/listenThis/'+this.currentId()+'/'+e.target.checked)
                                .then(response => {
                                    const tag = this.state.tag;
                                    tag.listenThis = b;
                                    this.setState({tag:tag});
                                })
                                .catch(error => alert(error.message));
                            }}/>
                        </ListItemSecondaryAction>
                    </MenuItem>
                    :'' 
                }  
                 
            </Menu>
        );
    }
    render() {
        const isFolder = this.currentItem() && this.currentItem().hasChildren;
        const isFile = this.currentItem() && !this.currentItem().hasChildren;
        const isViewable = this.currentItem() && VIEWABLETYPES.indexOf(this.currentItem().type) > -1;
        const name = this.currentItem() ? this.currentName() : null;
        const roleName = this.currentItem() ? this.currentRoleName() : null;
        const { isAdmin } = this.state;
        const isAllowDeliverReport = false;
        const isAllowNewClient = isAdmin;
        const isAllowNewFolder = isAdmin && isFolder;
        const isAllowRename = isAdmin;
        const isAllowPreview = !isFolder && isViewable;
        const isAllowDownload = !isFolder;
        const isAllowUpload = (isFolder && (isAdmin || (name && name.includes("Upload"))));
        const isAllowDelete = isAdmin;

        return(
            <div>
                <Toolbar style={{ backgroundColor: '#eee', boxShadow: '3px 3px #ccc', borderRadius: '3px' }}>
                        <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>DocX</Typography>
                        {
                            isAllowDeliverReport ?
                                <Tooltip title={'Deliver Report'}><div><IconButton onClick={this.deliverReport}><DeliverReportIcon /></IconButton></div></Tooltip>
                                :''
                        }

                        <TextFiled label='Filter Clients' onChange={e => this.onClientFilterChanged(e.target.value)} variant='outlined' />

                        {
                            isAllowNewClient ?
                                <Tooltip title={'New Client'}><div><IconButton onClick={this.newClient}><NewClientIcon /></IconButton></div></Tooltip>
                                :''
                        }
                        {
                            isAllowPreview ?
                                <Tooltip title={'Preview ' + name}><div><IconButton onClick={this.view}><ViewIcon /></IconButton></div></Tooltip>
                                :''
                        }
                        {
                            isAllowDownload ?
                                <Tooltip title={'Download ' + name}><div><IconButton disabled={!isFile} onClick={this.download}><DownloadIcon /></IconButton></div></Tooltip>
                                :''
                        }
                        {
                            isAllowNewFolder ?
                                <Tooltip title={'New Folder to '+name}><div><IconButton disabled={!isFolder} onClick={this.create}><NewIcon/></IconButton></div></Tooltip>
                                :''
                        }
                        {
                            isAllowRename ?
                                <Tooltip title={'Rename ' + name}><div><IconButton disabled={!this.currentId()} onClick={this.rename}><RenameIcon /></IconButton></div></Tooltip>
                                :''
                    }
                    
                    <input onChange={this.fileInputChanged} ref={ref => this.fileInput = ref} style={{ display: 'none' }} type='file' id='file' multiple />
                        {
                            isAllowUpload ?
                                <Tooltip title={'Upload to ' + name}><div><IconButton disabled={!isFolder} onClick={this.upload}><UploadIcon /></IconButton></div></Tooltip>
                                :''
                        }
                        {
                            isAllowDelete ?
                                <Tooltip className={this.classes.rightIcon} style={{ marginLeft: '100px' }} color='secondary' title={'Delete ' + name}>
                                    <div><IconButton disabled={!this.currentId()} onClick={this.delete}><DeleteIcon /></IconButton></div>
                                </Tooltip>
                                :''
                    }

                    {
                        isAdmin ?
                            <ToggleButtonGroup style={{ marginLeft: '100px' }}  value={this.state.isAllowMultipleDownload ? 'download' : ''}>
                                <ToggleButton value={'download'}
                                    onClick={() => {
                                        const isAllowMultipleDownload = !this.state.isAllowMultipleDownload;
                                        alert(isAllowMultipleDownload);
                                        this.initTree(isAllowMultipleDownload);
                                        this.loadIsAdmin();
                                        this.loadAllRoles();
                                        this.loadClients();
                                    }
                                    }>
                                    Multi Download</ToggleButton>
                            </ToggleButtonGroup>

                            : ''
                    }
                    {
                        this.state.isAllowMultipleDownload ?
                            <Tooltip title={'Download All Checked Files'}><div><IconButton onClick={this.downloadAllChecked}>
                                <DownloadAllIcon /></IconButton></div>
                            </Tooltip>
                            : ''
                    }
                        
                   </Toolbar>

                <br/>
                
                <div style={{display:'flex'}}>
                    <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }} id="tree" ></div>
                    <div style={{ flex: 1 }}>{this.createSidePanel(isAdmin,isAllowUpload)}</div>
                </div>
                <SimpleDialog ref={ref => this.simpleDialog = ref}/>
                <FormDialog ref={ref => this.formDialog = ref}/>
                <ViewDialog ref={ref => this.viewDialog = ref}/>
                <InfoDialog ref={ref => this.infoDialog = ref}/>
                <DeliverReportDialog ref={ref => this.deliverReportDialog = ref} showAxiosError={this.showAxiosError} />
                <AssignRoleDialog ref={ref => this.assignRoleDialog = ref} allRoles={this.state.allRoles}
                />
                {this.createContextMenu()}
            </div>
        );
    }
    onSelected(e,node,id){
        this.setState({selected:id});
        this.tree.expand(node);
        node.contextmenu(this.contextMenu);
        axios.get('api/docx/tag/'+id)
        .then(response => {
            this.setState({tag:response.data,isView:false});
        })
    }
    onUnSelected(e,node,id){
        this.setState({selected:null});
        node.off('contextmenu');
    }
    initTree(isAllowMultipleDownload) {
        //isAllowMultipleDownload = true;
        //alert(isAllowMultipleDownload);
        if (this.tree) {
            this.tree.destroy();
        }
        var tree = $('#tree').tree({
            uiLibrary: 'materialdesign',
            dataSource: [],
            checkboxes: isAllowMultipleDownload,
            textField:'name',
            primaryKey:'id',
            imageUrlField: 'flagUrl',
        });
        this.tree = tree;
        tree.on('select',this.onSelected);
        tree.on('unselect',this.onUnSelected);
        tree.on('expand',((e,node,id) => this.loadChildren(id)));
        $('#tree').contextmenu((e) => {
            e.preventDefault();
        });
    }
    componentDidMount(){
        this.initTree();
        this.loadIsAdmin();
        this.loadAllRoles();
        this.loadClients();
    }
}